import { decodeJwtPayload } from "@core/foundation/jwt";

import { UserClaimsSchema } from "@platform/core/models";

import { epochRepository } from "../../../repository/EpochRepository.ts";
import { gridConfigRepository } from "../../../repository/GridConfigRepository.ts";

export async function initConfig({
  authToken,
}: {
  readonly authToken: string;
}): Promise<void> {
  const { id: userId } = UserClaimsSchema.parse(decodeJwtPayload(authToken));
  const epoch = await epochRepository.ensureEpoch(userId);
  await gridConfigRepository.ensureConfig(userId, epoch.gridEpochId);
}
